function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Path, {
  d: "M12.717 17.508a4.793 4.793 0 11-.002-9.586 4.793 4.793 0 01.002 9.586zm8.307-2.28a.8.8 0 01.54-.525l2.336-.675a11.601 11.601 0 000-3.057l-2.337-.674a.8.8 0 01-.539-.525 8.772 8.772 0 00-.56-1.368.795.795 0 01.01-.752l1.168-2.132a11.382 11.382 0 00-2.161-2.162l-2.132 1.168a.801.801 0 01-.752.009 8.91 8.91 0 00-1.372-.56.801.801 0 01-.522-.538l-.675-2.336a11.575 11.575 0 00-3.057 0l-.673 2.335a.8.8 0 01-.523.539c-.506.163-.96.347-1.37.56a.798.798 0 01-.752-.009L5.52 3.358A11.295 11.295 0 003.358 5.52l1.17 2.132c.127.234.13.516.008.752-.214.412-.4.868-.561 1.37a.797.797 0 01-.54.523l-2.334.674a11.602 11.602 0 000 3.057l2.335.675a.8.8 0 01.539.522c.162.503.347.957.561 1.37a.8.8 0 01-.009.753L3.358 19.48a11.208 11.208 0 002.162 2.162l2.133-1.168a.799.799 0 01.751-.01c.414.214.87.4 1.371.56.254.082.45.284.523.54l.673 2.335a11.771 11.771 0 003.057 0l.675-2.336a.8.8 0 01.522-.539c.5-.16.957-.346 1.374-.561a.803.803 0 01.75.01l2.132 1.169a11.318 11.318 0 002.161-2.162l-1.168-2.132a.795.795 0 01-.01-.752c.215-.414.4-.87.56-1.369z",
  stroke: "#9C99B1",
  strokeWidth: 1.2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
});

function SvgIconSettings(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _ref);
}

export default SvgIconSettings;